const DEFAULT_RESPUESTAS = Object.freeze(["", "", "", ""]);

function createDefaultQuestion() {
  return {
    pregunta: "",
    respuestas: [...DEFAULT_RESPUESTAS],
    correcta: null,
    explicacion: "",
    editorTabKey: crypto.randomUUID(),
  };
}

/**
 * Deep-clone a test for the editor form. Handles null/undefined safely.
 * @param {object | null | undefined} test
 */
export function cloneTestForEditor(test) {
  const base = test !== null && typeof test === "object" ? test : {};
  const preguntasSrc = Array.isArray(base.preguntas) ? base.preguntas : [];
  const preguntasCopia = preguntasSrc.map((q) => {
    if (q && typeof q === "object") {
      const resp = Array.isArray(q.respuestas) ? [...q.respuestas] : [...DEFAULT_RESPUESTAS];
      const tabKeyRaw = q.editorTabKey;
      const editorTabKey =
        typeof tabKeyRaw === "string" && tabKeyRaw.length > 0 ? tabKeyRaw : crypto.randomUUID();
      return {
        pregunta: typeof q.pregunta === "string" ? q.pregunta : "",
        respuestas: resp,
        correcta: q.correcta ?? null,
        explicacion: typeof q.explicacion === "string" ? q.explicacion : "",
        imagenUrl: typeof q.imagenUrl === "string" ? q.imagenUrl : "",
        editorTabKey,
      };
    }
    return createDefaultQuestion();
  });
  if (preguntasCopia.length === 0) {
    preguntasCopia.push(createDefaultQuestion());
  }
  const pestanasRaw = base.pestanas;
  let pestanasOut = [];
  if (Array.isArray(pestanasRaw)) {
    pestanasOut = pestanasRaw.filter((p) => typeof p === "string");
  } else if (typeof pestanasRaw === "string") {
    pestanasOut = [pestanasRaw];
  }
  const clientKeyRaw = base.clientKey;
  const clientKey =
    typeof clientKeyRaw === "string" && clientKeyRaw.length > 0 ? clientKeyRaw : crypto.randomUUID();
  const rawPreguntasPorIntento = base.preguntasPorIntento;
  const preguntasPorIntento =
    typeof rawPreguntasPorIntento === "number" &&
    Number.isFinite(rawPreguntasPorIntento) &&
    rawPreguntasPorIntento > 0
      ? Math.max(1, Math.floor(rawPreguntasPorIntento))
      : null;

  return {
    titulo: typeof base.titulo === "string" ? base.titulo : "",
    tipo: typeof base.tipo === "string" ? base.tipo : "temario",
    tiempo: typeof base.tiempo === "number" && Number.isFinite(base.tiempo) ? base.tiempo : 0,
    preguntasPorIntento,
    preguntas: preguntasCopia,
    pestanas: pestanasOut,
    clientKey,
    notaMinima: base.notaMinima ?? null,
  };
}
